import { useEffect } from 'react';
import { LOCK_MAIN_SCROLL_CLASSNAME } from '../const/shared-selectors';

/*
    Caveat: this hook will not work if multiple elements that use it are open at the same time.
    If we ever need to support that scenario, it should be expanded to count the number of locks
    and only restore scrolling when all locks are removed.
*/

export const useScrollLock = (shouldLock: boolean) => {
    useEffect(
        function lockBodyScroll() {
            if (!shouldLock) {
                return;
            }

            const body = document.body;
            if (!body) {
                return;
            }

            body.classList.add(LOCK_MAIN_SCROLL_CLASSNAME);

            return () => {
                body.classList.remove(LOCK_MAIN_SCROLL_CLASSNAME);
            };
        },
        [shouldLock]
    );
};
